import * as Yup from "yup";
import {
  phoneRegex,
  yupTestCheckFileSize,
  yupTestCheckFileType,
} from "../../../utils/validation";

// initial values for the form
export const driverDetailsInitialValues = {
  driver_id: "",
  driver_image_url: "",
  driver_name: "",
  // nick_name: "", // not needed per client feedback
  contact_phone: "",
  contact_email: "",
  badge_employee_id: "",
  card_id: "",
  is_active: false,
  license_type: "",
  license_state: "",
  license_number: "",
  license_expiry_date: 0,
  license_status: "",
  medical_card_no: "",
  medical_card_expiry_date: 0,
  hazmat_certified: false,
  twic: "",
  twic_expiry_date: 0,
  address: "",
  vehicle_id: "",
};

// validation schema for the form
export const driverDetailsYupValidationSchema = Yup.object().shape({
  driver_id: Yup.string().required("Driver ID is required"),
  is_active: Yup.boolean().required("Is Active is required"),
  driver_name: Yup.string().required("Driver Name is required").max(40, "Driver Name must be at most 40 characters"),
  contact_email: Yup.string().matches(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    "Please enter a valid email address"
  ),
  contact_phone: Yup.string().matches(phoneRegex, "Invalid phone"),
});

export const driverUploadFormInitialValues = {
  driverid: "",
  image: null,
};
export const driverUploadFormValidationSchema = Yup.object().shape({
  driverid: Yup.string().required(),

  file: Yup.mixed<File>()
    .test("is-big-file", "VALIDATION_FIELD_FILE_BIG", yupTestCheckFileSize)
    .test(
      "is-correct-file",
      "VALIDATION_FIELD_FILE_WRONG_TYPE",
      yupTestCheckFileType
    ),
});
